__turbopack_context__.v({
  "badge": "ConferenceHero-module-scss-module__-xT76a__badge",
  "breadcrumbCurrent": "ConferenceHero-module-scss-module__-xT76a__breadcrumbCurrent",
  "breadcrumbLink": "ConferenceHero-module-scss-module__-xT76a__breadcrumbLink",
  "breadcrumbSeparator": "ConferenceHero-module-scss-module__-xT76a__breadcrumbSeparator",
  "breadcrumbs": "ConferenceHero-module-scss-module__-xT76a__breadcrumbs",
  "buttonGroup": "ConferenceHero-module-scss-module__-xT76a__buttonGroup",
  "container": "ConferenceHero-module-scss-module__-xT76a__container",
  "content": "ConferenceHero-module-scss-module__-xT76a__content",
  "ctaNote": "ConferenceHero-module-scss-module__-xT76a__ctaNote",
  "ctaSection": "ConferenceHero-module-scss-module__-xT76a__ctaSection",
  "gradientOrbs": "ConferenceHero-module-scss-module__-xT76a__gradientOrbs",
  "hero": "ConferenceHero-module-scss-module__-xT76a__hero",
  "highlight": "ConferenceHero-module-scss-module__-xT76a__highlight",
  "orb1": "ConferenceHero-module-scss-module__-xT76a__orb1",
  "orb2": "ConferenceHero-module-scss-module__-xT76a__orb2",
  "primaryButton": "ConferenceHero-module-scss-module__-xT76a__primaryButton",
  "pulse": "ConferenceHero-module-scss-module__-xT76a__pulse",
  "secondaryButton": "ConferenceHero-module-scss-module__-xT76a__secondaryButton",
  "seoHeading": "ConferenceHero-module-scss-module__-xT76a__seoHeading",
  "stat": "ConferenceHero-module-scss-module__-xT76a__stat",
  "statContent": "ConferenceHero-module-scss-module__-xT76a__statContent",
  "statIcon": "ConferenceHero-module-scss-module__-xT76a__statIcon",
  "statLabel": "ConferenceHero-module-scss-module__-xT76a__statLabel",
  "statNumber": "ConferenceHero-module-scss-module__-xT76a__statNumber",
  "stats": "ConferenceHero-module-scss-module__-xT76a__stats",
  "subtitle": "ConferenceHero-module-scss-module__-xT76a__subtitle",
  "title": "ConferenceHero-module-scss-module__-xT76a__title",
  "titleLine": "ConferenceHero-module-scss-module__-xT76a__titleLine",
});
